'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { connect } from 'react-redux';
import { fetchByPath } from 'DesignData/actions/CustomWidgetBuffers';
import CustomWidgetEditor from './CustomWidgetEditor';
const mapDispatchToProps = {
  fetchCustomWidgetBuffer: fetchByPath
};

function CustomWidgetEditorByPathContainer(props) {
  return /*#__PURE__*/_jsx(CustomWidgetEditor, Object.assign({}, props));
}

export default connect(null, mapDispatchToProps)(CustomWidgetEditorByPathContainer);